// import "@oddcamp/cocoon-vanilla-js";
import "cocoon-js-vanilla";

const PLACEHOLDER = "{{cocoonInsertId}}";

const computeInsertIds = (insertedElement) => {
  if (!insertedElement.innerHTML.includes(PLACEHOLDER)) return;

  const named = insertedElement.querySelector("input[name], select[name], textarea[name]");
  const cocoonInsertId = named?.name.match(/\[(\d+)\]\[[^\]]*\]$/)?.[1];
  if (cocoonInsertId === undefined) return;

  insertedElement.innerHTML = insertedElement.innerHTML.replaceAll(PLACEHOLDER, cocoonInsertId);
}

document.addEventListener('cocoon:after-insert', (event) => {
  const insertedElement = event.detail[2];
  computeInsertIds(insertedElement);
});

document.addEventListener('page:load', () => {
  document.querySelectorAll('.nested-fields').forEach((insertedElement) => {
    computeInsertIds(insertedElement);
  });
});
